export default "__VITE_ASSET__BvvVGy_W__"